export const SIGNUP = 'DEFAULT';
export const SIGNUP_URL = '';
export const ENABLE_NEWS = true;
export const USE_ESM_INDEX = false;
export const PROD = true;
export const LIVE_PROD = false;
export const PROD_SERVER_URL = undefined;
export const PROD_SOCKET_URL = undefined;
export const PROD_EDIS_SERVER_URL = undefined;
export const PROD_REST_SERVER_URL = undefined;
export const REST_BUILD = false;
export const PARTNER_BUILD = false;
export const BOCO_ENABLED = true;
